<template>
  <div class="d-flex justify-space-between align-end flex-wrap ga-3 mt-6 pt-4">
    <div class="text-disabled font-size-11">
      <div>Дата створення: {{ createdAt }}</div>
      <div>Дата оновлення: {{ updatedAt }}</div>
    </div>

    <v-btn
      v-if="dialog.params.hideActionButtons"
      color="white"
      elevation="1"
      rounded="lg"
      style="border: 1px solid #e4e4e7"
      variant="flat"
      @click="$emit('close')">
      Закрити
    </v-btn>
  </div>
</template>

<script>
import { useUserCardStore } from '@/dialog/components/user-card/store'

export default {
  name: 'UserCardFooter',
  emits: ['close'],
  setup() {
    return useUserCardStore()
  },
}
</script>
